import { getProfileName, hasMyChartAuthorizedEpicFeature } from './Utils.js';


export function getProfileMenuItems(props, state) {
    const { bundle, EnableProfileDashboard, hasMyChart, epicEHRDown, currentUser, Covid19AgeForVaccine, serverData, isProxyUser
        , isEmployee, canAccessThrive, thriveDataSuccess, thriveData, currentPharmacyUser, isMyChartInActive } = props;
    const { enableHappyTogether, enableThrive365Tile, enableThriveWellness } = serverData;
    const profileName = getProfileName(props);
    const pathname = typeof window !== "undefined" ? window.location.pathname.toLowerCase() : "";
    const isPharmacy = bundle === "pharmacy" || pathname.indexOf('/pharmacy') === 0;
    const isMyBSWHealth = bundle === "mybswhealth" && !isPharmacy;
    const notPharmacyProxy = isMyBSWHealth || isPharmacy && !currentPharmacyUser;
    const isMyChartProxyUser = isProxyUser;
    const showThriveWellness = isEmployee && enableThriveWellness && thriveDataSuccess; // Show Wellness Assessment
    const surveyStatusComplete = (thriveData && thriveData.surveyStatus) ? (thriveData.surveyStatus && thriveData.surveyStatus.toLowerCase() === "complete") : false;
    return {
        icon: 'icon-profile',
        show: notPharmacyProxy,
        navHead: {
            label: profileName,
            url: null
        },
        navItems: [
            {
                label: EnableProfileDashboard ? 'Patient Profile' : 'Personal Info',
                show: notPharmacyProxy,
                url: EnableProfileDashboard ? null : '/demographics',
                altUrls: EnableProfileDashboard ? null : ['/admininfo'],
                subMenuItems: EnableProfileDashboard ?
                    {
                        menuLabel: "Personal Info",
                        menuItems: [
                            {
                                label: 'Personal Info',
                                show: notPharmacyProxy,
                                url: '/demographics',
                                altUrls: ['/admininfo']
                            },
                            {
                                label: 'MyBSWHealth Profile',
                                show: notPharmacyProxy,
                                url: '/profiledashboard'
                            },

                        ]
                    } : null
            },
            {
                label: 'Health Summary',
                show: notPharmacyProxy && hasMyChart,
                url: '/healthsummary',
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive
            },
            {
                label: 'Vaccine Credentials',
                show: notPharmacyProxy && hasMyChart && currentUser && currentUser.ay >= Covid19AgeForVaccine,
                url: '/vaccinecredentials',
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive
            },
            {
                label: 'Medical Tools',
                show: notPharmacyProxy && hasMyChart,
                url: null,
                disabled: epicEHRDown || isMyChartInActive,
                subMenuItems:
                {
                    menuLabel: "Medical Tools",
                    menuItems: [
                        {
                            label: 'Download My Record',
                            show: notPharmacyProxy && hasMyChart,
                            url: '/medicalrecord'
                        },
                        {
                            label: 'Who\'s Accessed My Record',
                            show: notPharmacyProxy && hasMyChart,
                            url: '/audit'
                        },
                        {
                            label: 'Growth Charts',
                            show: notPharmacyProxy && hasMyChart,
                            url: '/growthcharts'
                        },
                        {
                            label: 'Questionnaires',
                            show: notPharmacyProxy && hasMyChart,
                            url: '/questionnaires'
                        },
                        {
                            label: 'Track My Health',
                            show: notPharmacyProxy && hasMyChart && hasMyChartAuthorizedEpicFeature("hasAuthorizedFeatureTrackMyHealth",props,state),
                            url: '/trackmyhealth'
                        },
                        {
                            label: 'Wallet Card',
                            show: notPharmacyProxy && hasMyChart,
                            url: '/walletcard'
                        }
                    ]
                }
            }, {
                label: 'My Conditions',
                show: notPharmacyProxy && hasMyChart && hasMyChartAuthorizedEpicFeature("hasAuthorizedFeatureMyConditions",props,state),
                url: '/myconditions',
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive
            },
            {
                label: 'Plan of Care',
                show: notPharmacyProxy && hasMyChart,
                url: '/planofcare',
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive
            },
            {
                label: 'Upcoming Tests & Procedures',
                show: notPharmacyProxy && hasMyChart,
                url: '/upcomingtests',
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive
            }, {
                label: 'Test Results',
                show: notPharmacyProxy && hasMyChart,
                url: '/testresults',
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive
            },
            {
                label: 'Preventive Care',
                show: notPharmacyProxy && hasMyChart,
                url: '/todo',
                altUrls: ['/healthmaintenance'],
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive
            },
            {
                label: 'Medical History',
                show: notPharmacyProxy && hasMyChart,
                url: '/medicalhistory',
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive
            },
            {
                label: 'Advance Directives',
                show: notPharmacyProxy && hasMyChart,
                url: '/directives',
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive
            },
            {
                label: 'Manage Community Accounts',
                show: notPharmacyProxy && hasMyChart && enableHappyTogether,
                url: '/communitymanage',
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive
            },
            {
                label: 'Thrive',
                show: notPharmacyProxy && !isMyChartProxyUser && !isEmployee && canAccessThrive,
                url: '/thrive',
                subMenuItems: null
            },
            {
                label: 'Wellness',
                show: notPharmacyProxy && !isMyChartProxyUser && isEmployee,
                url: null,
                subMenuItems:
                {
                    menuLabel: "Wellness",
                    menuItems: [
                        {
                            label: 'Thrive',
                            show: !enableThrive365Tile && notPharmacyProxy && !isMyChartProxyUser && isEmployee && canAccessThrive,
                            url: '/thrive'
                        },
                        {
                            label: 'Well-Being Assessment',
                            show: notPharmacyProxy && !isMyChartProxyUser && isEmployee && showThriveWellness && (surveyStatusComplete === false),
                            url: '/wellnessassessment'
                        },
                        {
                            label: 'Well-Being Report',
                            show: !enableThrive365Tile && notPharmacyProxy && !isMyChartProxyUser && isEmployee && showThriveWellness && (surveyStatusComplete === true),
                            url: '/wellnessreport'
                        },
                        {
                            label: 'Dashboard',
                            show: enableThrive365Tile && notPharmacyProxy && !isMyChartProxyUser && isEmployee && showThriveWellness && (surveyStatusComplete === true),
                            url: '/wellbeingdashboard'
                        },
                        {
                            label: 'Report',
                            show: enableThrive365Tile && notPharmacyProxy && !isMyChartProxyUser && isEmployee && showThriveWellness && (surveyStatusComplete === true),
                            url: '/wellbeingreport'
                        }
                    ]
                }
            }
        ]
    };
}